export default __webpack_public_path__ + "static/media/On-goingAI.dd81a1ad.svg";